import { createContext } from "react";
import type { ChatMessageDto } from "../../contracts";
import type { ChatControllerActions } from "../controller/useChatController";

export type ChatConversationRuntime = {
    chatMessages: ChatMessageDto[];
    isChatBusy: boolean;
    actions: ChatControllerActions;
};

export const ChatConversationContext = createContext<ChatConversationRuntime | undefined>(undefined);
